import request from 'store/common/utils';
export const getCountriesDictionaryApi = () => request({
    url: '/countries/dictionary',
    method: 'GET',
});
export const getAvailableContinentsApi = () => request({
    url: '/continents/available',
    method: 'GET',
});
export const getContinentsOverviewApi = () => request({
    url: '/continents/overview',
    method: 'GET',
});
